// 给出需要隐藏客户搜索框的路由名
let searchIsShowList = [
  'taskReport',
  'enquiryStatistic',
  'enquiryStatisticsDetail',
	'taskflow',
	'taskflowConf',
	'versionControl',
	'addRole',
	'saas',
	'setMealConfig',
	'couponsConfig',
	'renewalWhitelist',
	'garbageInquiryFilter',
	'blacklist',
	'whiteList',
	'functionUpdateDescription',
	'emailHost',
];

export default searchIsShowList;
